export type UserInfo = {
    user: UserBasicInfo;
    notification: { emailenabled: boolean; smsenabled: boolean };
    session: { sessionEnabled: boolean };
};
export type UserBasicInfo = {
    fName: string | null;
    lName: string | null;
    email: string;
    phone: string | null;
    countryCode?: string | null;
};

export enum ChangePasswordDialogProgress {
    Initial,
    Failed,
    Succeeded,
}
export enum UserRole {
    SiteUser = 'Site User',
    OrgAdmin = 'Organization Admin',
    LocationAdmin = 'Location Admin',
    EatonAdmin = 'Eaton Admin',
    Unassigned = 'Unassigned',
}
export enum UserOperations {
    UserManagement = 'WAS_UserManagement',
    SiteManagement = 'WAS_SiteManagement',
    DeleteUser = 'WAS_DeleteUser',
    AddSite = 'WAS_AddSite',
    DeleteLocation = 'WAS_DeleteLocation',
}
export type Role = Array<{
    roleId: string;
    siteId: string[];
    roleName: string;
    roleDescription: string;
    operations?: string[] | undefined;
}>;

export type SiteRoleData = {
    siteId: string;
    siteName: string;
    siteAddress: string | null;
    roleName: string;
    roleId: string;
    operations: string[];
};

export type RoleLocationList = Array<{
    index: number;
    roleId: string;
    disabledLocations: Array<{ siteId: string; siteName: string }>;
    roleList: Array<{ roleId: string; roleName: string }>;
    selectedLocation: Array<{ siteId: string; siteName: string }>;
}>;

export type SiteRole = {
    roleId: string;
    siteIds: string[];
};
export type AssociatedSiteRole = {
    roleId: string;
    siteIds: Array<{ siteId: string; siteName: string; disabled: boolean }>;
    disabled: boolean;
};
